윈도우11 | WINDOWS11 | ZENOSX | KBS1FM | 오연서윈도우, 윈도우11, 소프트웨어, 하드웨어, Q&A, 뉴스, 팁, 사용기, 유틸리티, 배경화면, 자유게시판, 사진갤러리, 특가, 홍보, 장터// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: 
	// $w("#anchor6")

	// Click "Preview" to run your code
});



$w('#button15').onClick((event) => {
    navigator.userAgent = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.3';    
})